import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import("../views/Imbox.vue"),
    },
    {
      path: '/resume',
      name: 'Resume',
      component: () => import("../views/Resume.vue"),
    },
    {
      path: '/files',
      name: 'Files',
      component: () => import("../views/Files.vue"),
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import("../views/Contact.vue"),
    },
    {
      path: '/topics/letter-to-hey',
      name: 'CoverLetter',
      component: () => import("../views/CoverLetter.vue"),
    },
    {
      path: '*',
      name: 'Page Not Found',
      component: () => import("../views/PageNotFound.vue"),
    }
  ],
  mode: 'history'
})




